import { createSelector } from 'reselect';
import { hasAccess, hasAdminAccess } from 'invision-core/src/components/security/permission.service';
export var HasAdminAccessHelper = function HasAdminAccessHelper(inputSelectors, ACCESS_LEVEL) {
  return createSelector(inputSelectors, function (userSecurityAttributes) {
    return hasAdminAccess(userSecurityAttributes, ACCESS_LEVEL);
  });
};
export var HasAccessHelper = function HasAccessHelper(inputSelectors, ACCESS_LEVEL) {
  return createSelector(inputSelectors, function (userSecurityAttributes) {
    return hasAccess(userSecurityAttributes, ACCESS_LEVEL);
  });
};